/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_MessageInputs */

const en_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const es_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje`)
};

const de_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

const zh_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ar_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرسالة`)
};

const fr_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const vi_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tin nhắn`)
};

const sw_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujumbe`)
};

const th_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อความ`)
};

const bs_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poruka`)
};

const ja_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

const ko_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지`)
};

const pt_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

const it_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio`)
};

const sv_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelande`)
};

const nl_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht`)
};

const da_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelelse`)
};

const nb_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melding`)
};

const fi_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viesti`)
};

const pl_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość`)
};

const ru_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение`)
};

const tr_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj`)
};

const hi_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदेश`)
};

const id_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan`)
};

const ms_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesej`)
};

const cs_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpráva`)
};

const el_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μήνυμα`)
};

const he_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעה`)
};

const af_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boodskap`)
};

const hu_contact_label_message = /** @type {(inputs: Contact_Label_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üzenet`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Contact_Label_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_label_message = /** @type {((inputs?: Contact_Label_MessageInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_MessageInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_label_message(inputs)
	if (locale === "de") return de_contact_label_message(inputs)
	if (locale === "zh") return zh_contact_label_message(inputs)
	if (locale === "ar") return ar_contact_label_message(inputs)
	if (locale === "fr") return fr_contact_label_message(inputs)
	if (locale === "vi") return vi_contact_label_message(inputs)
	if (locale === "sw") return sw_contact_label_message(inputs)
	if (locale === "th") return th_contact_label_message(inputs)
	if (locale === "bs") return bs_contact_label_message(inputs)
	if (locale === "ja") return ja_contact_label_message(inputs)
	if (locale === "ko") return ko_contact_label_message(inputs)
	if (locale === "pt") return pt_contact_label_message(inputs)
	if (locale === "it") return it_contact_label_message(inputs)
	if (locale === "sv") return sv_contact_label_message(inputs)
	if (locale === "nl") return nl_contact_label_message(inputs)
	if (locale === "da") return da_contact_label_message(inputs)
	if (locale === "nb") return nb_contact_label_message(inputs)
	if (locale === "fi") return fi_contact_label_message(inputs)
	if (locale === "pl") return pl_contact_label_message(inputs)
	if (locale === "ru") return ru_contact_label_message(inputs)
	if (locale === "tr") return tr_contact_label_message(inputs)
	if (locale === "hi") return hi_contact_label_message(inputs)
	if (locale === "id") return id_contact_label_message(inputs)
	if (locale === "ms") return ms_contact_label_message(inputs)
	if (locale === "cs") return cs_contact_label_message(inputs)
	if (locale === "el") return el_contact_label_message(inputs)
	if (locale === "he") return he_contact_label_message(inputs)
	if (locale === "af") return af_contact_label_message(inputs)
	if (locale === "hu") return hu_contact_label_message(inputs)
	return en_contact_label_message(inputs)
});